module.exports = __webpack_public_path__ + "static/media/fa-solid-900.c2801fb4.svg";